import { format, parse } from 'date-fns';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectMWComparatorControlPanelDates,
  setDates,
} from 'redux/reducers/meteorologyWeatherComparatorControlPanelReducer';
import { store } from 'redux/store';

export default function useDates({ modelIndex, accordionId }: {
  modelIndex: number,
  accordionId: string,
}) {
  const dates = useSelector(selectMWComparatorControlPanelDates);
  const date = useMemo(
    () => (dates[modelIndex] ? parse(dates[modelIndex], 'yyyy-MM-dd', new Date()) : null),
    [dates, modelIndex],
  );
  const closeAccordion = useMemo(() => buildAccordionClickFunction(accordionId), [accordionId]);
  const setDate = useCallback((d: Date | null) => {
    const formattedDate = d ? format(d, 'yyyy-MM-dd') : undefined;
    const newDates = [...dates];
    newDates[modelIndex] = formattedDate;
    store.dispatch(setDates(newDates));
    closeAccordion();
  }, [dates, modelIndex, closeAccordion]);
  const maxDate = new Date();
  const filterDate = useCallback((d: Date) => d.getDate() === 1, []);

  return {
    date,
    setDate,
    maxDate,
    filterDate,
  };
}
